module.exports = __webpack_public_path__ + "img/doc.734ba1e8.png";